const acceptAllCheckbox = document.querySelector('#edit-accept-all');
const otherCheckboxes = document.querySelectorAll('#edit-notifications, #edit-marketing');

// When "Accept all" is clicked
if (acceptAllCheckbox) {

  acceptAllCheckbox.addEventListener('change', function () {
    if (otherCheckboxes) {

      otherCheckboxes.forEach(checkbox => {
        checkbox.checked = this.checked;
      });

    }

  });

}

// When any other checkbox is clicked
if (otherCheckboxes) {

  otherCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {

      if (acceptAllCheckbox) {

        if (!this.checked) {
          acceptAllCheckbox.checked = false;
        }
        else {
          const allChecked = Array.from(otherCheckboxes).every(checkbox => checkbox.checked);
          if (allChecked) {
            acceptAllCheckbox.checked = true;
          }
        }

      }

    });
  });

}

